// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import NodeViewModel from "./../../factories/node-view-model";
import ChildTabViewModel from "./../../../factories/child-tab-view-model";
import TabPage from "./../../../factories/tab-page";
import BaoDialogViewModel from "./../../../factories/bao-dialog";
import TreeNodeViewModel from "./../../../factories/tree-node";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../../bindings/bao-searcher";
import "./../../../bindings/bao-toolbar2";
import "./../../../bindings/sorting";
import "./../../../bindings/filtering";
import "./../../bindings/permission-tree";
function RolePermissionTabModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.Role = parent;

    interface RolePermissionRequestModel {
        PermissionId: string;
        Value: boolean;
    }

    self.CompleteCheck = function () {
        return true;
    };


    self.FilterForms = ko.observableArray([]);
    self.SelectedFilterForms = ko.observable(0);
    self.SelectedFilterForms.subscribe(function (value) {
        self.FillFormCollection(self.ApplicationId(), true, self.ModuleId(), value, self.PermissionName());
    });


    self.CustomFilter = ko.observableArray([]);
    self.CustomFilter.subscribe(function () {
        self.FillFormCollection(self.ApplicationId(), true, self.ModuleId(), self.SelectedFilterForms(), self.PermissionName());
    });
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.FillFormCollection(self.ApplicationId(), false, self.ModuleId(), self.SelectedFilterForms(), self.PermissionName());
    });
    self.PageSize = ko.observable(20);
    self.PageSize.subscribe(function () {
        self.FillFormCollection(self.ApplicationId(), true, self.ModuleId(), self.SelectedFilterForms(), self.PermissionName());
    });
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.FillFormCollection(self.ApplicationId(), false, self.ModuleId(), self.SelectedFilterForms(), self.PermissionName());
    });
    self.ApplicationId = ko.observable();
    self.ApplicationId.subscribe(function (value) {
        self.FillFormCollection(value, true, self.ModuleId(), self.SelectedFilterForms(), self.PermissionName());
    });
    self.ApplicationName = ko.observable();
    self.FormCollection = ko.observableArray([]);
    self.SelectedFormRow = ko.observable();
    self.SelectedFormRow.subscribe(function (item) {
        self.FillNodeCollectionByForm(item);
    });
    self.AllModules = ko.observable(true);
    self.AllModules.subscribe(function (item) {
        if (item) {
            self.ModuleName("");
            self.ModuleId(null);
        }
    });
    self.ModuleId = ko.observable("");
    self.ModuleId.subscribe(function (item) {
        self.FillFormCollection(self.ApplicationId(), true, self.ModuleId(), self.SelectedFilterForms(), self.PermissionName());
    });
    self.ModuleName = ko.observable();

    self.PermissionName = ko.observable("").extend({ rateLimit: 1000 });
    self.PermissionName.subscribe(function (value) {
        self.FillFormCollection(self.ApplicationId(), true, self.ModuleId(), self.SelectedFilterForms(), value);
    });

    self.Nodes = ko.observableArray([]);
    self.SelectedFormPermission = ko.observable();
    self.ClickedFormPermission = ko.observable();
    self.ClickedFormPermission.subscribe(function (item) {
        if (item != null) {
            self.Role.TabPage.DirtyFlag(true);
            let result: RolePermissionRequestModel[] = [];
            const permission = self.CheckFormPermission(item, !item.Checked());
            if (permission)
                result.push(permission);

            if (item.Checked()) {
                let permissions: RolePermissionRequestModel[] = self.MoveUp(item.Parent, true);
                if (permissions && permissions.length > 0)
                    result = result.concat(permissions);

                permissions = self.MoveDown(item, true);
                if (permissions && permissions.length > 0)
                    result = result.concat(permissions);
            }
            else {
                let permissions: RolePermissionRequestModel[] = self.MoveDown(item, false);
                if (permissions && permissions.length > 0)
                    result = result.concat(permissions);
            }

            Bao.post("Uadm/RoleTab/SetRolePermissionValues", JSON.stringify({
                sessionTabId: self.Role.TabPage.SessionTabId,
                roleId: self.Role.RoleId(),
                permissions: result
            }))
                .always(_ => tabPage.IsLoading(false));
        }
    });
    self.MoveUp = function (node, value): RolePermissionRequestModel[] {
        let result: RolePermissionRequestModel[] = [];
        if (node != null) {
            const permission = self.CheckFormPermission(node, value);
            if (permission)
                result.push(permission);
            const permissions: RolePermissionRequestModel[] = self.MoveUp(node.Parent, value);
            if (permissions && permissions.length > 0)
                result = result.concat(permissions);
        }
        return result;
    };
    self.MoveDown = function (node, value): RolePermissionRequestModel[] {
        let result: RolePermissionRequestModel[] = [];
        if (node.Nodes() != null) {
            var index;
            for (index = 0; index < node.Nodes().length; ++index) {
                const permission = self.CheckFormPermission(node.Nodes()[index], value);
                if (permission)
                    result.push(permission);
                const permissions: RolePermissionRequestModel[] = self.MoveDown(node.Nodes()[index], value);
                if (permissions && permissions.length > 0)
                    result = result.concat(permissions);
            }
        }
        return result;
    };
    self.CheckFormPermission = function (node, value): RolePermissionRequestModel {
        if (node != null && node.CheckBoxVisible()) {
            if (node.Checked() != value) {
                node.Checked(value);
                self.CheckOtherEntries(self.Nodes(), node.PermissionId(), node.Checked());
                tabPage.IsLoading(true);
                return {
                    PermissionId: node.PermissionId(),
                    Value: node.Checked()
                };
            }
        }
        return null;
    };
    self.CheckOtherEntries = function (nodes, permissionId, checked) {
        if (nodes != null) {
            for (var index = 0; index < nodes.length; index++) {
                if (nodes[index].PermissionId() == permissionId) {
                    if (nodes[index].Checked() != checked) {
                        nodes[index].Checked(checked);
                    }
                }
                self.CheckOtherEntries(nodes[index].Nodes(), permissionId, checked);
            }
        }
    };
    self.FillFormCollection = function (applicationId, resetPageIndex, moduleId, formFilter, permissionName) {
        if (resetPageIndex && self.PageIndex() != 0) {
            self.PageIndex(0);
            return;
        }
        tabPage.IsLoading(true);
        return Bao.post("Uadm/RoleTab/GetFormCollectionWithFormFilter", JSON.stringify({
            applicationId: applicationId,
            moduleId: moduleId,
            formFilter: formFilter,
            roleId: self.Role.RoleId(),
            permissionName: permissionName,
            customFilter: self.ToHashObject(self.CustomFilter()),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedFormRow(null);
            self.TotalRows(0);
            self.FormCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.FormCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            tabPage.IsLoading(false);
        });
    };
    self.ToHashObject = function (customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({
                Key: f,
                Value: ko.unwrap(customFilter[f])
            });
        }
        return returnValue;
    };
    self.FillRolePermissionCollection = function () {
        return Bao.post("Uadm/RoleTab/GetRolePermissionCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId()
        }));
    };
    self.FillNodeCollection = function (formId) {
        tabPage.IsLoading(true);
        return Bao.post("Uadm/RoleTab/GetFormPermissionCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            formId: formId,
            moduleId: self.ModuleId()
        }), function (value) {
            var dataSource = [];
            if (value.nodes != null) {
                for (var i = 0; i < value.nodes.length; i++) {
                    var treeNodeViewModel = new TreeNodeViewModel(value.nodes[i]);
                    treeNodeViewModel.CountVisible = true;
                    dataSource.push(treeNodeViewModel);
                }
            }
            self.Nodes(dataSource);
            tabPage.IsLoading(false);
        });
    };
    self.FormPermissionClicked = function (item) { };
    self.InitPermissions = function (item) {
        if (item != null) { }
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("Uadm/RoleTab/ResetRolePermission", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId
        }), function () {
            self.FillRolePermissionCollection()
                .then(_ => {
                    return self.FillNodeCollectionByForm(self.SelectedFormRow());
                })
                .then(function () {
                    def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("Uadm/RoleTab/SaveRolePermissionCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            saveTime: parent.SaveTime()
        }));
    };
    self.Copy = function (roleId, saveTime) {
        return Bao.post("Uadm/RoleTab/CopyRolePermissionCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            newRoleId: roleId,
            saveTime: saveTime
        }));
    };
    self.GetFormFilters = function () {
        return Bao.get("Uadm/RoleTab/GetFormPermissionFilters", function (result) {
            self.FilterForms(result);
        });
    }
    self.init = function () {
        return $.when(self.GetFormFilters(), self.FillRolePermissionCollection());
    };
    self.loaded = function () {
        self.ApplicationId(Bao.Session.Application.ApplicationId());
        self.ApplicationName(Bao.Session.Application.ApplicationName());
    };

    /**
     * Fill node collection using the selected form
     * @param item SelectedFormRow
     */
    self.FillNodeCollectionByForm = function (item) {
        if (item != null) {
            return self.FillNodeCollection(item.FormId);
        }
        else {
            return self.FillNodeCollection(null);
        }
    }
}
;

export default RolePermissionTabModel;